module.exports = __webpack_public_path__ + "static/media/heart-rate.fbba80a2.svg";